import React from "react";
import { useSelector } from "react-redux";
import style from "./measurementStatus.module.scss";
import { Button } from "../../../primary";
import { MeasurementLoader } from "./measurementLoader";

export const MeasurementStatus = ({ showMeasurementModal, pendingRetires, maxPendingRetries, isReadOnly, isUserTrace }) => {
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const status = measurementData?.status;
  const isStickerAvailable = measurementData?.isStickerAvailable === 1;

  const errorStatus = status === "error" || status === "no_measurements";

  return (
    <div className="col pl-4">
      <div>
        <div className="mb-3">
          {status === "pending" && !isUserTrace && (
            <>
              <MeasurementLoader pendingRetires={pendingRetires} maxPendingRetries={maxPendingRetries} />
            </>
          )}
          {status === "pending" && isUserTrace && (
            <div style={{ textAlign: "center" }} className={`${style.dim_man_p}`}>
              Tap{" "}
              <Button
                type="button"
                value="Replay"
                classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                id="autoMeasurement"
                onClick={() => {
                  showMeasurementModal("PlaceDot");
                }}
                disabled={isReadOnly}
              />{" "}
              to place wound dot.
            </div>
          )}
          {isStickerAvailable && errorStatus && (
            <>
              <p className={`${style.dim_man_p}`}>
                Tap{" "}
                <Button
                  type="button"
                  value="Retrace"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  id="autoMeasurement"
                  onClick={() => {
                    showMeasurementModal("Retrace Wound Edges");
                  }}
                  disabled={isReadOnly}
                />{" "}
                to redraw wound edges, or enter{" "}
                <Button
                  type="button"
                  value="Dimensions"
                  id="autoMeasurement"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  onClick={() => showMeasurementModal("Dimensions")}
                  disabled={isReadOnly}
                />{" "}
                manually.
              </p>
            </>
          )}

          {!isStickerAvailable && (errorStatus || status === "do_manual_trace") && (
            <>
              <p className={`${style.dim_man_p}`}>
                Enter{" "}
                <Button
                  type="button"
                  value="Dimensions"
                  id="autoMeasurement"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  onClick={() => showMeasurementModal("Dimensions")}
                  disabled={isReadOnly}
                />{" "}
                manually.
              </p>
            </>
          )}
          {isStickerAvailable && status === "do_manual_trace" && (
            <>
              <p className={`${style.dim_man_p}`}>
                Tap{" "}
                <Button
                  type="button"
                  value="Retrace"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  id="autoMeasurement"
                  onClick={() => {
                    showMeasurementModal("Retrace Wound Edges");
                  }}
                  disabled={isReadOnly}
                />{" "}
                to redraw wound edges.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
